import types from "../../utils/actionTypes";

const initialState = {
    numOfNewOrders: null
}

export default function(state=initialState, action){
    switch(action.type){
        case types.NEW_ORDERS:
            return {...state, numOfNewOrders: action.payload}
        case types.CLEAR_NEW_ORDERS:
            return {...state, numOfNewOrders: null}
        case types.DECREMENT_NEW_ORDERS:
            return {...state, numOfNewOrders: state.numOfNewOrders - 1}
        default: return {...state}
    }  
}